export default __webpack_public_path__ + "static/media/disc_results.499958b2.png";